<template>
  <v-container>
    <div class="container-inner">
      <PageTitle title="Users" />
      <div class="alerts-wrapper" v-if="currentUserPlan.name === 'Free' || currentUserPlan.name === 'No Plan'">
        <div class="alerts-wrapper__icon">
          <v-img width="24px" height="24px" src="@/assets/icons/svg/alert.svg" />
        </div>
        <div class="alerts-wrapper__text">
          You can invite up to {{ getLimit('users') }} users with your current plan.
        </div>
      </div>
      <div class="table-wrapper mt-6">
        <v-row class="table-controls mb-1 items-center">
          <v-col sm="6" md="6" lg="6">
            <v-btn
              v-if='getUsed("users")<getLimit("users")'
              color='transparent'
              depressed
              @click="inviteNewUser"
              class='px-2'
            >
              <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
              <span class="text-subtitle-2 font-weight-bold">Invite User</span>
            </v-btn>
            <v-btn
              v-else
              color='transparent'
              depressed
              @click="showUpgradeSubscriptionPlanPopup"
              class='px-2'
            >
              <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
              <span class="text-subtitle-2 font-weight-bold">Invite User</span>
            </v-btn>
          </v-col>
          <v-col sm="6" md="6" lg="6">
            <div class="d-flex justify-end">
              <v-card flat class="items-center filter-select" style="width: 250px !important; background-color: transparent; position: relative">
                <span class="filter-title">Show:</span>
                <v-select
                  v-model="filterUsers"
                  outlined
                  dense
                  color="black"
                  :items="filterUsersOptiones"
                  placeholder="All Users"
                  hide-details
                />
              </v-card>
            </div>
          </v-col>
        </v-row>
        <v-divider />
        <v-row class="justify-space-between">
          <v-col cols="12" class="px-0">
            <v-data-table
              :headers="headers"
              :items="items"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              item-key="id"
              hide-default-footer
              @page-count="pageCount = $event"
            >
              <template v-slot:no-results>
                <p class="text-h5 mt-16">No Users</p>
              </template>
              <template v-slot:[`item.selected`]>
                <v-simple-checkbox
                  color="#7972c0"
                  :ripple="false"
                />
              </template>
              <template v-slot:[`item.inviteStatus`]="{ item }">
                <span
                  v-if="item.inviteStatus === 'accepted'"
                  style="
                    background-color: #d6f7e2;
                    color: #3d654d;
                    border-radius: 4px;
                  "
                  class="pa-1"
                  >{{ item.inviteStatus }}</span
                >
                <span
                  v-else
                  style="
                    background-color: #fff1d6;
                    color: #b67501;
                    border-radius: 4px;
                  "
                  class="pa-1"
                  >{{ item.inviteStatus }}</span
                >
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-row class="flex-nowrap">
                  <v-col cols="6" class="px-1" v-if='item.inviteStatus !== "owner"'>
                    <router-link class="ml-1" :to='{name: "EditUser", params: {id: item.id}}'>
                      <img
                        style="height: 16px; width: 16px"
                        src="@/assets/icons/svg/draw.svg"
                        title="Edit"
                      />
                    </router-link>
                  </v-col>
                  <v-col cols="6" class="px-1">
                    <img
                      style="height: 16px; width: 16px"
                      src="@/assets/icons/svg/delete1.svg"
                      @click="deleteUser(item.id)"
                      v-if="item.inviteStatus != 'owner'"
                      class="cursor-point"
                      title="Delete"
                    />
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row class="pagination-wrapper">
          <v-col cols="5">
            <span class="text-nowrap mr-2">Items per page</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  style="padding: 0; font-weight: 600"
                >
                  {{ itemsPerPage }}
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in [5, 10, 20, 25, 50]"
                  :key="index"
                  link
                  @click="itemsPerPage = item"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="7" class="d-flex justify-end">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="6"
              color="#7972C0"
            />
          </v-col>
        </v-row>
      </div>
    </div>
    <edit-user
      v-model="showEditUser"
      :value="showEditUser"
      :user="tmpUserData"
      :id="tmpUserID"
    />
    <invite-user v-model="showInviteUser" :value="showInviteUser" />
    <v-dialog v-model="resendDialog" class="resendDialog" width="520">
      <v-card class="pa-4">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
          style="color: #919196 !important"
        >
          Invite User
        </v-card-title>

        <v-card-text class="mt-5">{{ resendMessage }} </v-card-text>
        <v-card-actions>
          <v-btn
            text
            height="40"
            @click="resendDialog = false"
            class="ma-auto resend-ok-btn"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- user delete modal -->
    <v-dialog v-model="userDeleteDialog" persistent max-width="520">
      <v-card class="pa-4">
        <v-card-title class="headline justify-center popup-title">
          Are you sure to delete this user?
        </v-card-title>
        <v-card-actions class="text-xs-center justify-center">
          <v-btn
            @click="userDeleteDialog = false"
            depressed
            class="cancel-btn small-size"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="confirmDeleteuser"
            depressed
            class="save-btn small-size"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EditUser from '@/components/manage-user/EditUser'
import InviteUser from '@/components/manage-user/InviteUser'
import PageTitle from '@/components/page/PageTitle'
import { getLimitMixin } from '@/mixins/getLimit'
export default {
  components: {
    PageTitle,
    EditUser,
    InviteUser
  },
  data() {
    return {
      currentUserPlan: {},
      showEditUser: false,
      showInviteUser: false,
      resendDialog: false,
      tmpUserData: '',
      tmpUserID: '',
      resendMessage: '',
      filterUsers: '',
      filterUsersOptiones: [
        'All Users',
        'Confirmed Users',
        'Unconfirmed Users'
      ],
      headers: [
        {
          text: 'First Name',
          align: 'start',
          sortable: true,
          value: 'firstName'
        },
        {
          text: 'Last Name',
          value: 'lastName',
          sortable: true,
          align: 'start'
        },
        { text: 'Role', value: 'role', sortable: true, align: 'start' },
        { text: 'Email', value: 'email', sortable: true, align: 'start' },
        {
          text: 'Phone Number',
          value: 'phone',
          sortable: true,
          align: 'start'
        },
        { text: 'Created', value: 'dateAdded', sortable: true, align: 'start' },
        {
          text: 'Last Active',
          value: 'lastActive',
          sortable: true,
          align: 'start'
        },
        {
          text: 'Status',
          value: 'inviteStatus',
          sortable: true,
          align: 'start'
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'start'
        }
      ],
      itemsPerPage: 10,
      page: 1,
      pageCount: 0,
      userDeleteDialog: false,
      selectedUserId: ''
    }
  },
  mixins: [getLimitMixin],
  computed: {
    ...mapGetters('user', ['invitedUsers']),
    items() {
      if (this.filterUsers === 'Unconfirmed Users') {
        return JSON.parse(
          JSON.stringify(
            this.invitedUsers.filter((el) => el.inviteStatus === 'invited')
          )
        )
      } else if (this.filterUsers === 'Confirmed Users') {
        return JSON.parse(
          JSON.stringify(
            this.invitedUsers.filter((el) => el.inviteStatus !== 'invited')
          )
        )
      } else {
        return JSON.parse(JSON.stringify(this.invitedUsers))
      }
    }
  },
  methods: {
    ...mapActions('user', ['inviteUser', 'getInvitedUsers', 'delInvitedUser']),
    ...mapActions(['showUpgradeSubscriptionPlanPopup']),
    deleteUser(id) {
      this.userDeleteDialog = true
      this.selectedUserId = id
    },
    confirmDeleteuser() {
      this.userDeleteDialog = false
      this.delInvitedUser(this.selectedUserId).then((res) => {
        if (res.data.error.type === 200) {
          this.getInvitedUsers()
        } else {
          this.$store.dispatch('showSubmitFormErrorPopup', {
            title: 'Error to delete',
            message: res.data.error.message
          })
        }
      })
    },
    submitUser() {
      this.inviteUser(this.userToSubmit)
    },
    async resend(user) {
      await this.inviteUser(user).then((res) => {
        if (res.status === 200) {
          this.resendDialog = true
          this.resendMessage = `Invitation has been resent to email ${user.email} successful.`
        } else this.resendDialog = false
      })
    },
    modalEditUser(selectedUserData, index) {
      this.tmpUserData = selectedUserData
      this.tmpUserID = index
      this.showEditUser = true
    },
    inviteNewUser() {
      if (this.invitedUsers.length > this.currentUserPlan.limitUsers) {
        this.$toasted.error('You cannot add more than 3 users', {
          theme: 'toasted-primary',
          position: 'bottom-right',
          icon: {
            name: 'close'
          },
          duration: 5000
        })
      } else {
        this.$router.replace({ name: 'AddUser' })
      }
    },
    async editUser(user) {
      await this.$store.commit('user/set', {
        type: 'user',
        val: user
      })
      this.$router.push({ name: 'AddUser' })
    }
  },
  created() {
    this.currentUserPlan = JSON.parse(localStorage.getItem('curUserData')).plan
  }
}
</script>

<style scoped lang="scss">

</style>

<style lang="scss">
.theme--light.v-pagination .v-pagination__item {
  background: #f5f5f5;
  box-shadow: none;
  border: 1px solid #8a8a8a;
}
.theme--light.v-pagination .v-pagination__navigation {
  background: #f5f5f5;
  box-shadow: none;
  border: 1px solid #8a8a8a;
}
.eventHandle {
  visibility: hidden;
}
.eventHandle img {
  width: 25px;
  height: 25px;
}
.actionField:hover .eventHandle {
  visibility: inherit;
}
.userTable {
  width: 100%;
}
.userTable th {
  font-size: 12px;
  color: rgb(29, 34, 43);
}
.userTable td {
  height: 60px !important;
}
.invite-num-span {
  display: inline-block;
  font-style: normal;
  font-stretch: normal;
  word-break: break-word;
  color: rgb(29, 34, 43);
  font-family: HelveticaNeue, sans-serif;
  font-weight: bold;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  padding: 0px 0px 16px;
  display: block;
}
.invite-num-description {
  display: inline-block;
  font-style: normal;
  font-stretch: normal;
  word-break: break-word;
  color: rgb(29, 34, 43);
  font-family: HelveticaNeue, sans-serif;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.2px;
  padding: 0px 0px 38px;
  display: block;
}
.username {
  display: inline-block;
  font-style: normal;
  font-stretch: normal;
  word-break: break-word;
  color: rgb(29, 34, 43);
  font-family: HelveticaNeue, sans-serif;
  font-weight: bold;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.2px;
}
.useremail {
  display: inline-block;
  font-style: normal;
  font-stretch: normal;
  word-break: break-word;
  color: rgb(113, 117, 130);
  font-family: HelveticaNeue, sans-serif;
  font-size: 10px;
  line-height: 1.43;
  letter-spacing: 0.2px;
}
.inviteUser {
  color: rgb(0, 150, 188);
}
.r-field {
  padding-top: unset;
  margin-top: unset;
}
.userInfo {
  display: inline-block;
  font-style: normal;
  font-stretch: normal;
  word-break: break-word;
  color: rgb(29, 34, 43);
  font-weight: bold;
  font-family: HelveticaNeue, sans-serif;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.2px;
}
.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  min-height: 50px;
}
.invite-user-btn {
  width: 20%;
  /* background-color: #6452a2 !important; */
  background-image: linear-gradient(to right, #8074c2, #4c486b);
  color: white !important;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 1rem !important;
  margin-right: 20px;
}
.invite-user-btn:hover {
  width: 20%;
  border: 2px solid #6452a2;
  background-color: #f5f5f5 !important;
  color: #f5f5f5 !important;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 1rem !important;
}
.label-field {
  font-size: 1rem !important;
  color: #413967;
  font-family: 'Source Sans 3', sans-serif;
}
.resend-ok-btn {
  width: 20%;
  /* background-color: #6452a2 !important; */
  background-image: linear-gradient(to right, #8074c2, #4c486b);
  color: white !important;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 1rem !important;
  margin-right: 20px;
}
.resend-ok-btn:hover {
  width: 20%;
  border: 2px solid #6452a2;
  background-color: #f5f5f5 !important;
  color: #f5f5f5 !important;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 1rem !important;
}
</style>
